export function initScrollImages() {
  const containers = Array.from(document.querySelectorAll(".scroll-image-container"));
  const images = Array.from(document.querySelectorAll(".scroll-image"));
  const texts = Array.from(document.querySelectorAll(".scroll-image-text"));

  if (!containers.length || !images.length || !texts.length) return;

  const update = () => {
    for (let i = 0; i < containers.length; i += 1) {
      const container = containers[i];
      const image = images[i];
      const text = texts[i];
      if (!container || !image || !text) continue;

      const imageHeight = image.offsetHeight;
      const imageBottom = image.getBoundingClientRect().top + window.scrollY + imageHeight;
      const textHeight = text.offsetHeight;
      const textBottom = text.getBoundingClientRect().top + window.scrollY + textHeight;
      const windowHeight = window.innerHeight;
      const containerTop = container.getBoundingClientRect().top + window.scrollY;

      if (window.innerWidth >= 991 && textHeight >= 1000) {
        const shouldPin =
          containerTop <= window.scrollY + 220 &&
          (imageBottom <= textBottom - 100 || text.getBoundingClientRect().bottom >= windowHeight);
        const shouldRelease =
          imageBottom <= textBottom - 100 &&
          text.getBoundingClientRect().bottom < windowHeight;

        if (shouldPin) {
          image.style.position = "fixed";
          image.style.top = "220px";
          image.style.width = `${container.offsetWidth}px`;
          image.classList.remove("w-100");
        } else if (shouldRelease) {
          image.style.top = "auto";
          image.style.position = "relative";
          image.classList.add("w-100");
        } else {
          image.style.position = "absolute";
          image.classList.remove("w-100");
          image.style.top = `${textBottom - imageHeight - 99}px`;
        }
      } else {
        image.style.position = "relative";
        image.style.bottom = "auto";
        image.style.top = "auto";
        image.classList.add("w-100");
      }
    }
  };

  update();
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update, { passive: true });
}
